<!--
발송작업 > 작업안내
-->
<template>
    <div class="guide uk-position-relative">
        <div v-if="guideType === 'error'">
            <h2>
                <i class="material-icons">build</i>
                <span class="uk-text-middle">오류상품 발송작업</span>
                (보관장소에서 상품을 가져오세요)
            </h2>

        </div>

        <div v-if="guideType === 'hold'">
            <h2>
                <i class="material-icons">build</i>
                <span class="uk-text-middle">보류상품 발송작업</span>
                (보관장소에서 상품을 가져오세요)
            </h2>

        </div>

        <div v-if="guideType === 'etc'">
            <h2>
                <i class="material-icons">build</i>
                <span class="uk-text-middle">발송작업</span>
                (반드시 요청메모 확인 후 발송하세요)
            </h2>

        </div>

        <div v-if="guideType === 'stock'">
            <h2>
                <i class="material-icons">build</i>
                <span class="uk-text-middle">재고상품 발송작업</span>
                (재고상품의 가져올 수량에 주의하세요)
            </h2>

        </div>

        <!-- 작업취소 버튼 -->
        <button
            class="uk-button uk-button-gray uk-position-top-right"
            @click="$emit('cancel')"
        >
            <i class="material-icons">cancel</i>
            CANCEL
        </button>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 배송상품
            shipProd: Object,

            // 재고상품
            stockProd: Object,
        },
        data: function () {
            return {
            };
        },
        computed: {
            /**
             * 가이드 종류
             *  - 오류발송
             *  - 보류발송
             *  - 재고발송
             *  - 기타발송
             */
            guideType() {
                if (this.stockProd) {
                    return 'stock';

                } else if (this.shipProd && this.shipProd.lock_error) {
                    return 'error';

                } else if (this.shipProd && this.shipProd.lock_hold) {
                    return 'hold';
                }

                return 'etc';
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .guide {
        //background-color: #fff;
        //border: 1px solid #ddd;
        //padding: 1rem;
        text-align: center;
        font-size: 1.5rem;
        color: #000;

        h2 {
            font-size: 1.5rem;
            .material-icons {
                font-size: 1.75rem;
            }
            margin-bottom: 10px;
        }
    }
</style>